import { useLocation } from '@reach/router';
import { navigate } from 'gatsby';

function useQueryParameters() {
	const location = useLocation();

	const getQueryParameters = () => {
		let params = {};
		const searchParameters = new URLSearchParams(location.search);

		searchParameters.forEach((value, key) => {
			params[key] = value.includes(',') ? value.split(',') : value;
		});

		return params;
	};

	const resetQueryParameters = (keys) => {
		const searchParameters = new URLSearchParams(location.search);

		for (const key of keys) {
			searchParameters.delete(key);
		}

		navigate(`${location.pathname}?${searchParameters.toString()}`);
	};

	const setQueryParameter = (key, value) => {
		const searchParameters = new URLSearchParams(location.search);

		if (Array.isArray(value)) {
			if (value.length) {
				searchParameters.set(key, value.join(','));
			} else {
				searchParameters.delete(key);
			}
		} else if (value || value === 0) {
			searchParameters.set(key, value);
		} else {
			searchParameters.delete(key);
		}

		navigate(`${location.pathname}?${searchParameters.toString()}`);
	};

	return {
		queryParameters: getQueryParameters(),
		resetQueryParameters,
		setQueryParameter,
	};
}

export default useQueryParameters;
